// use of 1024 instead of 1000 because Firefox does the same, so the download
// size shown matches what's reported by the browser.
export function humanizeBytes(bytes: number) {
  const UNITS: [string, number][] = [
    ["TB", 1024 * 1024 * 1024 * 1024],
    ["GB", 1024 * 1024 * 1024],
    ["MB", 1024 * 1024],
    ["KB", 1024],
  ];

  for (const [unit, size] of UNITS) {
    const partial = bytes / size;
    if (partial > 1) {
      return `${partial.toFixed(1)}${unit}`;
    }
  }

  return `${bytes} bytes`;
}
